import { render, staticRenderFns } from "./AlarmUpgrade.vue?vue&type=template&id=2a0811f0&scoped=true&"
import script from "./AlarmUpgrade.vue?vue&type=script&lang=js&"
export * from "./AlarmUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./AlarmUpgrade.vue?vue&type=style&index=0&id=2a0811f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0811f0",
  null
  
)

export default component.exports